var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-openrouter-form" },
    [
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
            ]),
            _vm._v(" "),
            _c("a-input", {
              attrs: { placeholder: _vm.$t("whatsappChannel.channelName") },
              model: {
                value: _vm.form.channelName,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "channelName", $$v)
                },
                expression: "form.channelName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("message.apiKeyMode") || "API Anahtarı Modu")
              ),
            ]),
            _vm._v(" "),
            _c(
              "a-radio-group",
              {
                staticClass: "key-mode-group",
                model: {
                  value: _vm.form.keyMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "keyMode", $$v)
                  },
                  expression: "form.keyMode",
                },
              },
              [
                _c(
                  "a-radio",
                  { staticClass: "key-mode-option", attrs: { value: "byok" } },
                  [
                    _c("div", { staticClass: "key-mode-content" }, [
                      _c("span", { staticClass: "key-mode-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.byokTitle") ||
                              "Kendi API Anahtarımı Kullanacağım (BYOK)"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "key-mode-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.byokDesc") ||
                              "OpenRouter hesabınızdaki API anahtarınızı kullanın"
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-radio",
                  {
                    staticClass: "key-mode-option disabled",
                    attrs: { value: "supsis", disabled: "" },
                  },
                  [
                    _c("div", { staticClass: "key-mode-content" }, [
                      _c(
                        "span",
                        { staticClass: "key-mode-title" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("message.supsisKeyTitle") ||
                                  "Supsis AI API Anahtarı Sağlasın"
                              ) +
                              "\n                            "
                          ),
                          _c("a-tag", { attrs: { color: "orange" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("chatbotv2.comingSoon") || "Yakında"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "key-mode-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.supsisKeyDesc") ||
                              "Supsis tarafından sağlanan API anahtarı ile kullanın"
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.form.keyMode === "byok"
          ? _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.openrouterApiKey") || "OpenRouter API Key"
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("a-input-password", {
                  attrs: { placeholder: _vm.$t("message.openrouterApiKey") },
                  model: {
                    value: _vm.form.apiKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "apiKey", $$v)
                    },
                    expression: "form.apiKey",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "help-text" },
                  [
                    _c("a-icon", { attrs: { type: "info-circle" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("message.openrouterApiKeyHint") ||
                              "API anahtarınızı"
                          ) +
                          "\n                    "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://openrouter.ai/keys",
                            target: "_blank",
                          },
                        },
                        [_vm._v("OpenRouter Dashboard")]
                      ),
                      _vm._v(
                        "\n                    " +
                          _vm._s("üzerinden alabilirsiniz.") +
                          "\n                "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.$t("message.cancel"))),
          ]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSave },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("message.save")) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }